import { registerComponent } from "helpers";
import WYATTElement from "wyatt";

registerComponent(
  "delivery-check-form",
  class DeliveryCheckForm extends WYATTElement {
    constructor() {
      super();

      this.searchForm = this.querySelector("[data-search-form]");
      this.searchInput = this.querySelector("[data-search-input]");
      this.availabilityResultsAvailable = this.querySelector(
        "[data-availability-results='available']",
      );
      this.availabilityResultsUnavailable = this.querySelector(
        "[data-availability-results='unavailable']",
      );
      this.deliveryAddress = this.querySelector("[data-delivery-address]");
      this.resetButton = this.querySelector("[data-reset]");

      this.handleSearchSubmitBound = this.handleSearchSubmit.bind(this);
      this.resetBound = this.reset.bind(this);
      this.onSetup = this.setup.bind(this);

      this.hidden = true;
    }

    connectedCallback() {
      this.subscribe(WYATT.PubSub.events.storesFetched, this.onSetup);

      this.searchForm.addEventListener("submit", this.handleSearchSubmitBound);

      this.resetButton.addEventListener("click", this.resetBound);
    }

    disconnectedCallback() {
      super.disconnectedCallback();

      this.searchForm?.removeEventListener(
        "submit",
        this.handleSearchSubmitBound,
      );
      this.resetButton?.removeEventListener("click", this.resetBound);
    }

    get formData() {
      return new FormData(this.searchForm);
    }

    get location() {
      return this.formData.get("location");
    }

    setup() {
      this.hidden = false;
    }

    async handleSearchSubmit(event) {
      event.preventDefault();

      if (!this.location) {
        return;
      }

      const updated = await WYATT.Geolocation.updateLocationFromSearchForm(
        this.searchForm,
      );

      if (!updated) {
        return;
      }

      this.checkAvailability();
    }

    checkAvailability() {
      const isAvailable = WYATT.Geolocation.deliveryAvailable();

      if (isAvailable) {
        this.availabilityResultsAvailable.hidden = false;
        this.availabilityResultsUnavailable.hidden = true;
      } else {
        this.availabilityResultsAvailable.hidden = true;
        this.availabilityResultsUnavailable.hidden = false;
      }

      this.deliveryAddress.textContent =
        WYATT.Geolocation.location.address?.formatted ?? "";
    }

    reset() {
      this.availabilityResultsAvailable.hidden = true;
      this.availabilityResultsUnavailable.hidden = true;
      this.deliveryAddress.textContent = "";
      this.searchInput.value = "";
      this.searchInput.focus();
    }
  },
);
